import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c36ad80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lp-card lp-header" }
const _hoisted_2 = { class: "lp-header__main" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "lp-header__info" }
const _hoisted_5 = { class: "lp-header__title" }
const _hoisted_6 = { class: "lp-header__description" }
const _hoisted_7 = { class: "lp-header__badges" }
const _hoisted_8 = {
  key: 1,
  class: "lp-header__actions"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-linkedin" }, null, -1))
const _hoisted_11 = { class: "lp-header__stats" }
const _hoisted_12 = { class: "lp-header__progress" }
const _hoisted_13 = { class: "lp-header__progress-label" }
const _hoisted_14 = { class: "lp-bar" }

import { computed } from 'vue';
import { IResources, PLANS_URL, hasAccess, resourceHref, useLearningPathI18n } from './learningPath';


export default /*#__PURE__*/_defineComponent({
  props: {
    pathway: null,
    pathwayId: null,
    currentResource: null
  },
  emits: ["share-linkedin"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'share-linkedin'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  pathway: any
  pathwayId: string
  currentResource: IResources | null
}





const { t, lang, tl } = useLearningPathI18n();

const LEVEL_TONES: Record<string, string> = {
  Beginner: 'green',
  Intermediate: 'purple',
  Advanced: 'red',
};

const TYPE_TONES: Record<string, string> = {
  'Offensive': 'red', 'General': 'green', 'Application Security': 'amber', 'Defensive': 'blue',
  'Threat Intelligence': 'purple', 'Incident Response': 'grey', 'Forensics': 'grey',
  'Reverse Engineering': 'red', 'Hardware': 'amber', 'Mobile': 'green', 'Cloud': 'blue', 'IOT': 'purple',
  'Network': 'grey', 'Web': 'grey', 'Wireless': 'red', 'OSINT': 'amber', 'Social Engineering': 'green',
  'Malware Analysis': 'blue', 'Cryptography': 'purple', 'Steganography': 'grey', 'Binary Analysis': 'grey',
  'Programming': 'red', 'Scripting': 'amber', 'DevOps': 'green', 'Cloud Security': 'blue',
  'Management': 'purple', 'Soft Skills': 'grey', 'Career': 'grey', 'Certification': 'red', 'Other': 'amber',
};

const percentage = computed(() => Number(props.pathway.percentage_completed) || 0);
const isCompleted = computed(() => percentage.value >= 100);

const status = computed(() => {
  if (isCompleted.value) return { label: t(`${lang.value}.user_progress.completed`), tone: 'green' };
  if (percentage.value > 0) return { label: t(`${lang.value}.user_progress.in_progress`), tone: 'amber' };
  return { label: t(`${lang.value}.user_progress.not_started_yet`), tone: 'grey' };
});

const stats = computed(() => [
  { icon: 'bi bi-camera-video', label: tl('lessons'), done: props.pathway.completed_lessons, total: props.pathway.total_lessons },
  { icon: 'bi bi-flag', label: tl('challenges'), done: props.pathway.completed_challenges, total: props.pathway.total_challenges },
  { icon: 'bi bi-display', label: tl('machines'), done: props.pathway.completed_machines, total: props.pathway.total_machines },
]);

const continueAction = computed(() => {
  const resource = props.currentResource;
  if (!resource) return null;
  if (!hasAccess(resource)) {
    return { href: PLANS_URL, label: tl('unlock'), icon: 'bi bi-lock-fill' };
  }
  const href = resourceHref(props.pathwayId, resource);
  if (!href) return null;
  return { href, label: percentage.value > 0 ? tl('continue_path') : tl('start_path'), icon: 'bi bi-arrow-right' };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.pathway.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.pathway.image,
            alt: __props.pathway.name,
            class: "lp-header__image"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(__props.pathway.name), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(__props.pathway.description), 1),
        _createElementVNode("div", _hoisted_7, [
          (__props.pathway.level)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["lp-tag", `lp-tag--${LEVEL_TONES[__props.pathway.level] || 'grey'}`])
              }, _toDisplayString(__props.pathway.level), 3))
            : _createCommentVNode("", true),
          (__props.pathway.type)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(["lp-tag", `lp-tag--${TYPE_TONES[__props.pathway.type] || 'grey'}`])
              }, _toDisplayString(__props.pathway.type), 3))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: _normalizeClass(["lp-tag", `lp-tag--${_unref(status).tone}`])
          }, _toDisplayString(_unref(status).label), 3)
        ])
      ]),
      (_unref(continueAction) || _unref(isCompleted))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_unref(continueAction))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _unref(continueAction).href,
                  target: "_blank",
                  class: "lp-btn"
                }, [
                  _createTextVNode(_toDisplayString(_unref(continueAction).label) + " ", 1),
                  _createElementVNode("i", {
                    class: _normalizeClass(_unref(continueAction).icon)
                  }, null, 2)
                ], 8, _hoisted_9))
              : _createCommentVNode("", true),
            (_unref(isCompleted))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: _normalizeClass(["lp-btn", { 'lp-btn--outline': _unref(continueAction) }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('share-linkedin')))
                }, [
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString(_unref(tl)('share_achievement')), 1)
                ], 2))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, [
          _createElementVNode("strong", null, _toDisplayString(_unref(percentage)) + "%", 1),
          _createTextVNode(" " + _toDisplayString(_unref(tl)('percent_completed')), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", {
            style: _normalizeStyle({ width: `${Math.min(_unref(percentage), 100)}%` })
          }, null, 4)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stats), (stat) => {
        return (_openBlock(), _createElementBlock("div", {
          key: stat.label,
          class: "lp-header__stat"
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(stat.icon)
          }, null, 2),
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(stat.done ?? 0) + "/" + _toDisplayString(stat.total ?? 0), 1),
            _createElementVNode("span", null, _toDisplayString(stat.label), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})